import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FailedApproaches() {
  const approaches = [{
    title: "Decirle 'ignóralos'",
    description: 'Falla porque el acosador interpreta el silencio como miedo, no como indiferencia.'
  }, {
    title: 'Quejarse con el profesor',
    description: "Sin pruebas documentadas permite que el colegio lo clasifique como un 'conflicto puntual' de patio."
  }, {
    title: "Sugerirle que 'devuelva el golpe'",
    description: 'Pone a un niño pacífico en una situación de riesgo físico y legal para la que no está preparado.'
  }, {
    title: "Esperar a que 'se cansen'",
    description: 'Solo cronifica el trauma y destruye la autoestima de tu hijo a largo plazo.'
  }];
  return <section className="py-20 md:py-24 bg-offwhite" data-id="element-14">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-15">
        <FadeIn data-id="element-16">
          <div className="text-center mb-16" data-id="element-17">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-18">
              Por qué lo que has intentado no funciona
            </h2>
            <div className="w-24 h-1 bg-amber mx-auto rounded-full" data-id="element-19"></div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-20">
          {approaches.map((approach, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-21">
              <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-navy/5 h-full flex items-start gap-4 transition-transform hover:-translate-y-1 duration-300" data-id="element-22">
                <div className="flex-shrink-0 mt-1" data-id="element-23">
                  <XCircle className="text-red-500" size={28} data-id="element-24" />
                </div>
                <div data-id="element-25">
                  <h3 className="text-xl font-bold text-navy mb-2" data-id="element-26">
                    {approach.title}
                  </h3>
                  <p className="text-navy/70 leading-relaxed" data-id="element-27">
                    {approach.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}